const ITEMS = [
    "Contabilità",
    "Amministrazione",
    "Consulenza",
    "Bandi",
    "Finanza agevolata",
    "Full remote",
    "Isernia",
    "Operatività nazionale",
];

export default function Marquee() {
    return (
        <section className="marquee border-y border-white/8 py-5 overflow-hidden bg-white/[0.015]" aria-label="Aree di attività">
            <div className="marquee-track flex">
                {[0, 1].map((dup) => (
                    <div key={dup} aria-hidden={dup === 1} className="flex items-center shrink-0">
                        {ITEMS.map((t) => (
                            <span key={t} className="flex items-center">
                                <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-white/45 px-8">
                                    {t}
                                </span>
                                <span className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-brand-start to-brand-end" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
